/* --------------------------------------------------------------------------------------------
Project Name: Rem2Cloud (R2C)
File Name: call-elevator.component.ts
File Description: call elevator component file

Copyright 2023 - 2024 Otis Elevator Company
The software on this media is protected by law. Unauthorized use, reproduction or reverse engineering without
the express permission of Otis Elevator Company. is strictly prohibited.
Unpublished Work. All Rights Reserved.
------------------------------------------------------------------------------------------------- */

import { Component, Inject, OnInit  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Constants } from 'src/app/shared/constants';
import { LocalDataService } from '../../services/local-data.service';
import { G3msService } from 'src/app/shared/services/g3ms_services/g3ms.service';
import { CommonService } from '../../services/common.service';
import { LocalizationService } from '../../localization/localization.service';
import { TwilioHelperService } from '../../services/twilio-helpers.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-call-elevator',
  templateUrl: './call-elevator.component.html',
  styleUrls: ['./call-elevator.component.scss']
})
export class CallElevatorComponent implements OnInit {

  callbackMsg : string | undefined;
  callbackError : string | undefined;
  connectingString: string | undefined;
  joining: string | undefined;
  loader = true;
  elevatorId: any;
  isAutoDialer:any;
  callBackElevatorIdField : any= this._twilioService.callBackElevatorIdField;
  constructor(public _dialogRef: MatDialogRef<CallElevatorComponent>,
              private _localDataService: LocalDataService,
              private g3msService: G3msService,
              private _notificationService : NotificationService,
              public _localizationService: LocalizationService,
              private commonService: CommonService,
              private _twilioService: TwilioHelperService,
              @Inject(MAT_DIALOG_DATA) public _data: any){
                _localizationService.use(this._localDataService.selectedCountry + '_' + this._localDataService.selectedLanguage, [...Constants.Localization.commonAreas, 'avaya_calls','elevator_call_details']);
        _localDataService.selectedScreen = ['avaya_calls','elevator_call_details'];
        
      /////this.callBackElevator(_data);
      
    }

    ngOnInit(): void {   
      // this._twilioService.callBackElevatorIdField.subscribe({
      //   next: (result: any) => {
      //       if(result != null)
      //       this.callBackElevatorIdField =  result;
  
      //       this.loader = (result.hasError == undefined)? true: false;          
      //   }, error(){
      //     //console.log(e)
      //   }, complete(){
      //     //console.log(" callBackElevatorIdFieldModal Completed");
      //   }
      // });  
        
        this.cccCallBackElevator(this._data);
    }

    // // callBackElevator(_data:any) {
    // //   let callDetail = document.getElementById(Constants.PAGE_CONSTANTS.avayaCalls.callbackModalName);

    // //   if (callDetail) {
    // //     this._dialogRef.close();
    // //   }

    // //   /*
    // //     * elevatorId: Id of the elevator
    // //     * uuid: '0': G3MS api will be called to get latest uuid and will be appended with this JSON.
    // //     * extn: Extension of the avaya user to get a call. Extension will be prefixed with 'X', like 'X1234'
    // //     * unique_identifier: unique value to identify callback
    // //     * command: for what CIMS is called.
    // //     * mediaRegion: media region to store video and audion of the call.
    // //   */
    // //    const loggedUser = this._localDataService.getLoginUserData();
    // //    this.elevatorId=_data.elevatorId;
    // //    var callBackObj = { 
    // //               countryShortName: loggedUser['user']['countryShortName'],
    // //               elevatorId: (this.elevatorId == undefined)? _data.UnitNumber:_data.elevatorId, 
    // //               //elevatorId: _data.elevatorId, 
    // //               uuid: '0', 
    // //               extn: loggedUser['user']['extn'], 
    // //               unique_identifier: this.getUniqUUID(), 
    // //               command: Constants.G3MS_COMMANDS.joinRoom, 
    // //               mediaRegion: '', 
    // //               volume: "",
    // //             };
    // //     this.connectingString = this._localizationService.instant('elevator_call_details.popupHeader')+ callBackObj.elevatorId;
    // //     this.joining = this._localizationService.instant('elevator_call_details.joining');
        
    // //     this.g3msService.callBackElevator(callBackObj).subscribe(
    // //     {
    // //       next: (res: any) => {
    // //         if(res.body.status){
    // //           this.isAutoDialer = 0;
    // //           if(res.body.data.isAutoDialer)
    // //           {
    // //             this.isAutoDialer = 1;
    // //           }
    // //           //this.connectingString = "";
    // //           this.joining = "";
    // //           //this.loader = false;
    // //           //Join_room will have roomdata sent by CIMS
    // //           ////let roomData = res.body.data.join_room;
    // //           // if (this.commonService.checkAndOfEverything(roomData)) {

    // //           //     /*
    // //           //     * rsp: response from CIMS
    // //           //     * rsp: 1 - Callback success, CPIB joined the room.
    // //           //     * rsp: 2 - Callback failed. cPIB is already in room and not able to join
    // //           //     * rsp: 3 & 0 - Error (Error during callback)
    // //           //     * rsp: 4 - Declained (Invalid country code)
    // //           //     */
    // //           //     // // switch (roomData.rsp) {
    // //           //     // //   case Constants.PAGE_CONSTANTS.callbackResponse.joinedRoom:
    // //           //     // //     this.callbackMsg = this._localizationService.instant('avaya_calls.joinedRoom');
    // //           //     // //     break;
    // //           //     // //   case Constants.PAGE_CONSTANTS.callbackResponse.alreadyInRoom:
    // //           //     // //     this.callbackMsg = this._localizationService.instant('avaya_calls.alreadyInRoom');
    // //           //     // //     break;
    // //           //     // //   case Constants.PAGE_CONSTANTS.callbackResponse.invalidCountryCode:
    // //           //     // //     this.callbackMsg = this._localizationService.instant('avaya_calls.invalidCountryCode');
    // //           //     // //     break;
    // //           //     // //   default:
    // //           //     // //     this.callbackMsg = this._localizationService.instant('avaya_calls.expOnCallback');
    // //           //     // //     break;
    // //           //     // // }
    // //           //   }

    // //         }
    // //         if (!res.body.status) {
    // //             if (res.body.err) {
    // //               this.callbackError = this.errorMsg(res);
    // //             }
    // //             else {
    // //               this.callbackError = 'invalidElevatorId'; 
    // //               //this._localizationService.instant('avaya_calls.invalidElevatorId');'invalidElevatorId';
    // //             }         
    // //             this.connectingString = "";
    // //             this.joining = "";
    // //             this.loader = false;
    // //             //this.commonService.showStatusMessage(PAGE_CONSTANTS.avayaCalls.clActivity);
    // //         }
    // //       },
    // //       error: (err: any) => {
    // //         this._dialogRef.close();
    // //       }
    // //     });
    // // }
     /*
    * To generate uniqueId to identify callback.
    * This will generate guid which will identified for the callback from OTISLinepbx
    */
     getUniqUUID() {
      return (Constants.PAGE_CONSTANTS.avayaCalls.uuidFunction.xguid).replace(Constants.PAGE_CONSTANTS.avayaCalls.uuidFunction.replaceRegEx, Constants.PAGE_CONSTANTS.avayaCalls.uuidFunction.function);
    }
 /*
    * Routing to show the error message after the callback. This receives the result from CIMS system.
    * @param1: res: result received from CIMS. Result will have error code sent by CIMS.
    */
    errorMsg(res:any) {
      var error;
      switch (res.body.err.statusCode) {
        case Constants.PAGE_CONSTANTS.avayaCalls.g3msStatus.C400:
          let getErrorMsg = (msg:any) =>{
            try {
              return msg.substr(0, msg.indexOf("."));
            }
            catch (e) {
              return msg;
            }
          };

          if(res.body.data != null) {
            error = this.commonService.checkOrOfNothing(res.body.data.message) ? Constants.APP_CONSTANTS.badRequest : getErrorMsg(res.body.data.message);
          } else {
            error = Constants.APP_CONSTANTS.badRequest;
          }
          break;

        //Error code reecived from CIMS
        case Constants.PAGE_CONSTANTS.avayaCalls.g3msStatus.C401:
          error = this._localizationService.instant('avaya_calls.unauthorized');
          break;

        //Error code reecived from CIMS
        case Constants.PAGE_CONSTANTS.avayaCalls.g3msStatus.C503:
          error = this._localizationService.instant('avaya_calls.sqlUnavailable');
          break;

        //Error code reecived from CIMS
        case Constants.PAGE_CONSTANTS.avayaCalls.g3msStatus.C500:
          error = this._localizationService.instant('avaya_calls.internalServerError');
          break;

        // When callback, media region will be fetched to create a room. If we updated invalid region, this error will be received from server.
        case Constants.PAGE_CONSTANTS.avayaCalls.g3msStatus.C1000:
          error = this._localizationService.instant('avaya_calls.invalidMediaRegion');
          break;

        //If No specific error from G3MS/CIMS, unknown error message will be shown.
        default:
          error = this._localizationService.instant('avaya_calls.expOnCallback');
          break;
      }

      return error;
    };

    cccCallBackElevator(_data:any)
    {
      this.callBackElevatorIdField =  {};
      ////(_data.elevatorId == undefined)? _data.UnitNumber:_data.elevatorId,
      this.elevatorId = (_data.elevatorId == undefined)? _data.elevatorUnitId:_data.elevatorId;
      this.connectingString = this._localizationService.instant('elevator_call_details.popupHeader')+ this.elevatorId;
        this.joining = this._localizationService.instant('elevator_call_details.joining');
        this._twilioService.callBackElevator(this.elevatorId,_data.uuid, _data.external);
        // // this._twilioService.manualcallstatus.subscribe({
        // //   next: (result: any) => {
        // //     if(result)
        // //     {
        // //       this.connectingString = result;
        // //       this.joining="";
        // //     }
        // //    }
        // // });
    }
    closePopup(){ 
      this._dialogRef.close();
    }
     ngOnDestroy(){
       //this._twilioService.callBackElevatorIdFieldModal.complete();
     }

    onDialogCancel(): void { 
      ////this.connectingString = "Unable to contact device at this time1. Please try again";
      this._twilioService.callBackElevatorIdField = {};
      this._twilioService.DisconnectManualcall();
      this._dialogRef.close();       
      this._notificationService.hideSnackBar(); 
      let currentStatus="Idle";
      let isFromModel='';
      let isUserRequest=true;
      this._twilioService.changeStatus(currentStatus, isFromModel, isUserRequest)        
      
    }
    closewindow()
    {
      this._dialogRef.close(); 
    }
}
